import { useEffect } from 'react';
import * as bip39 from 'bip39';
import { useGlobalStateSelector, words } from './globalState';
import { TextArea2 } from './UtilComponents';
import { handleClickLogin } from './login';
// import { handleClickSwapMnemonics } from './walletCore';
import {
  handleClickAuthenticate,
  UnregisterAddress,
  UnregisterCredential,
  SavePasswordEncryptedSecrets,
  LoadPasswordEncryptedSecrets,
} from './KeyBox';
import {
  handleClickGoTop,
  handleClickScanQr,
  writeNdefRecordsOnNfc,
  readNfc,
  decodeNdefRecord,
} from './utils';
import { writeNfcrwCallbackToLocalStorage, notifyNativeAppWriteResult } from './nativeApp';
import { useNfcrwScan, useNfcrwWrite } from './nativeAppHooks';
import { NativeAppWriteButton, NativeAppReadButton } from './NativeAppUI';
import {
  getAddressFromKey,
  getKeyPairsFromMnemonic,
  handleClickNfc,
  keepKeyPairsInMemory,
  walletsAvailable,
  encryptByKeyCardStyle,
  decryptByKeyCardStyle,
  formatToKeyCardStyle,
  formatToSingleTextRecord,
  generateMnemonic,
  getSecretsFromKeyCardRecords,
} from './keysAndSigning';
import iconKeyBox from './image/box_24dp_000000_FILL0_wght400_GRAD0_opsz24.svg';
import iconKeyCard from './image/playing_cards_FILL0_wght400_GRAD0_opsz24.svg';
import iconQr from './image/qr_code_2_FILL0_wght400_GRAD0_opsz24.svg';
import iconEdit from './image/edit_FILL0_wght400_GRAD0_opsz48.svg';

// // SWAP MNEMONICS
// // eslint-disable-next-line no-unused-vars
// function SwapMnemonics() {
//   const state = useGlobalStateSelector( ({ state }) => state );
//   const dispatch = useGlobalStateSelector( ({ dispatch }) => dispatch );
// 
//   if (process.env.REACT_APP_ENVIRONMENT === 'prod') {
//     return null;
//   }
// 
//   if (!('NDEFReader' in window)) {
//     return null;
//   }
// 
// 
//   return (
//     <div className='flexColumn alignItemsCenter borderKOM marginTop1 padding0p5'>
//       <div className='flexRow justifyContentSpaceBetween alignItemsCenter widthMax marginTop1 '>
//         <div>
//           { words.swapMnemonics[state.language] }
//         </div>
//         <button className='borderNone backgroundColorTransparent cursor borderRadius2 riseOut2 marginSide0p2 ' tabindex='0'
//           onClick={ () => handleClickClearAddress(state, dispatch) }
//         >
//           {words.clear[state.language]}
//         </button>
//       </div>
//       <button className='buttonMainColor widthMin20 heightMin4 flexRow justifyContentCenter alignItemsCenter marginTop1 ' tabindex='0'
//         onClick={ async () => {
//           handleClickSwapMnemonics(state, dispatch);
//         }}
//       >
//         <div>
//           { words.display[state.language] }
//         </div>
//         <div>
//           <img className='size2x2' src={iconKeyCard} alt='' />
//         </div>
//       </button>
//       <button className='buttonMainColor widthMin20 heightMin4 flexRow justifyContentCenter alignItemsCenter marginTop1 ' tabindex='0'
//         onClick={ async () => {
//           localStorage.removeItem('swapStatus');
//           localStorage.removeItem('oldAddress');
//           localStorage.removeItem('oldKeyPair');
//           localStorage.removeItem('oldMnemonic');
//           localStorage.removeItem('newAddress');
//           localStorage.removeItem('newMnemonic');
//           localStorage.removeItem('sweepAssetsTxid');
//           localStorage.removeItem('sendMonaTxid');
//           dispatch({ type: 'setStateMultiLayers', keys: ['displaySecret', 'swapMnemonics'], value: '' }); // 暫定
//         }}
//       >
//         <div>
//           { words.display[state.language] }
//         </div>
//         <div>
//           <img className='size2x2' src={iconKeyCard} alt='' />
//         </div>
//       </button>
//       <div className='flexColumn alignItemsFlexStart width90PC borderKOM breakAll marginTop1 padding0p5'>
//         { state.displaySecret.swapMnemonics }
//       </div>
//     </div>
//   );
// }

// SETTING
function Setting() {
  const language = useGlobalStateSelector(({ state }) => state.language || 'english');
  const navigate = useGlobalStateSelector(({ navigate }) => navigate);

  return (
    <div>
      {/* PC */}
      <div className="visibleMiddleOrMore flexColumn alignItemsCenter">
        <div className='flexRow justifyContentFlexEnd widthMax marginBottom1' >
          <div className='flexRow ' >
            <button className='button2' onClick={ () => handleClickGoTop({ navigate }) }>
              { words.back[language] }
            </button>
          </div>
        </div>
        {/* <UserRegistration mode='all' /> */}
        <SwitchDisplayName />
        <DisplayMnemonic />
        <DisplayWif />
        <DisplayAddress />
        {/* <SwapMnemonics /> */}
        <GetThePrivateKeyFromTheMnemonic />
        <UnregisterAddress />
        <UnregisterCredential />
        <SavePasswordEncryptedSecrets />
        <LoadPasswordEncryptedSecrets />
      </div>
      {/* SP */}
      <div className="visibleSmallOrLess flexColumn">
        <div className='flexRow justifyContentFlexEnd widthMax marginBottom1' >
          <button className='button2' onClick={ () => handleClickGoTop({ navigate }) }>
            { words.back[language] }
          </button>
        </div>
        {/* <UserRegistration mode='all' /> */}
        <DisplayMnemonic />
        <DisplayWif />
        <DisplayAddress />
        {/* <SwapMnemonics /> */}
        <GetThePrivateKeyFromTheMnemonic />
        <UnregisterAddress />
        <UnregisterCredential />
        <SavePasswordEncryptedSecrets />
        <LoadPasswordEncryptedSecrets />
      </div>
    </div>
  );
}

// SWITCH DISPLAY NAME
function SwitchDisplayName() {
  const { state, dispatch } = useGlobalStateSelector(({ state, dispatch }) => ({ state, dispatch }));


  return (
    <div className='flexColumn alignItemsCenter borderKOM marginTop1 padding0p5'>
      <div>
        { words.switchDisplayNamesInTheCardList[state.language] }
      </div>
      <div className='flexRow justifyContentSpaceBetween alignItemsCenter widthMax marginTop1 '>
        <button className={'box3 focusEffect01 riseOut2 ' + (state.displayName === 'cardName' ? 'colorRed borderSelected' : 'borderNone')}
          tabindex='0'
          onClick={ () => {
            dispatch({type: 'setState', key: 'displayName', value: 'cardName'});
          }}
        >
          <div>
            {words.monacardName[state.language]}
          </div>
        </button>
        <button className={'box3 focusEffect01 riseOut2 ' + (state.displayName === 'asset_longname' ? 'colorRed borderSelected' : 'borderNone')}
          tabindex='0'
          onClick={ () => {
            dispatch({type: 'setState', key: 'displayName', value: 'asset_longname'});
          }}
        >
          <div>
            {words.asset_longname[state.language]}
          </div>
        </button>
        <button className={'box3 focusEffect01 riseOut2 ' + (state.displayName === 'asset' ? 'colorRed borderSelected' : 'borderNone')}
          tabindex='0'
          onClick={ () => {
            dispatch({type: 'setState', key: 'displayName', value: 'asset'});
          }}
        >
          <div>
            {words.asset[state.language]}
          </div>
        </button>
      </div>
    </div>
  );
}

// DISPLAY MNEMONIC
function DisplayMnemonic(props) {
  const popupLayer = props.popupLayer;
  const popupLayerNext = popupLayer !== undefined && popupLayer !== null ? (popupLayer + 1) : 0;
  const mnemonic = useGlobalStateSelector( ({ state }) => state.displaySecret.mnemonic );
  const user = useGlobalStateSelector( ({ state }) => state.user );
  const login = useGlobalStateSelector( ({ state }) => state.login );
  const walletType = useGlobalStateSelector( ({ state }) => state.walletType );
  const session = useGlobalStateSelector( ({ state }) => state.session );
  const marginOfSessionTime = useGlobalStateSelector( ({ state }) => state.marginOfSessionTime );
  const assetInfos = useGlobalStateSelector( ({ state }) => state.assetInfo );
  const monacards = useGlobalStateSelector( ({ state }) => state.monacard );
  const hasCamera = useGlobalStateSelector( ({ state }) => state.device?.hasCamera );
  const pass = useGlobalStateSelector( ({ state }) => state.config.clientParameters.specialMessage );
  const network = useGlobalStateSelector( ({ state }) => state.networkMona );
  const clientParameters = useGlobalStateSelector( ({ state }) => state.config.clientParameters );
  const language = useGlobalStateSelector( ({ state }) => state.language || 'english' );
  const dispatch = useGlobalStateSelector( ({ dispatch }) => dispatch );
  const nativeAppAvailable = walletsAvailable({ hasCamera }).includes('nfcNative');

  // iPhone アプリで読み込む: アプリが読み取り結果を暗号化して返し、ブラウザで復号する
  const nfcrwScan = useNfcrwScan({
    enabled: nativeAppAvailable,
    language,
    clearOnUnmount: true,
    // records は Web NFC の形（Web NFC の読み込みボタンと同じ読み方をする）
    onRecords: async ({ records, intent }) => {
      if (intent === 'keycard') {
        const recordNo = 1;
        const record = records?.[recordNo];

        const encryptedMnemonic = decodeNdefRecord({ dispatch, record, language });
        const mnemonicFromKeyCard = await decryptByKeyCardStyle({ pass, dispatch, encrypted: encryptedMnemonic, language });
        handleClickDisplayMnemonic({ dispatch, mnemonics: [mnemonicFromKeyCard] });
        dispatch({ type: 'setNotification', key: 'notification', value: words.readingDone[language] });
      }
      else if (intent === 'plain') {
        const recordNo = 0;
        const record = records?.[recordNo];

        const text = decodeNdefRecord({ dispatch, record, language });
        handleClickDisplayMnemonic({ dispatch, mnemonics: [text] });
        dispatch({ type: 'setNotification', key: 'notification', value: words.readingDone[language] });
      }
      else {
        dispatch({ type: 'setNotification', key: 'notification', value: words.failedToReadNfc[language] });
        throw new Error(`unknown intent: ${intent}`);
      }
    },
    onFailure: () => {
      dispatch({ type: 'setNotification', key: 'notification', value: words.failedToReadNfc[language] });
    },
  });

  // iPhone アプリで書き込む: 1/2 で鍵交換、2/2 で暗号化したレコードを渡して書き込む
  // 2/2 のリンクを作ったあとで表示中のニーモニックが変わったら、1/2 からやり直しになる（source）
  const nfcrwWrite = useNfcrwWrite({
    enabled: nativeAppAvailable,
    language,
    clearOnUnmount: true,
    source: mnemonic,
    // レコードは Web NFC の形で作る（Web NFC の書き込みボタンと同じ）。アプリの形への変換はフックが行う
    buildRecords: async ({ intent }) => {
      if (intent === 'keycard') {
        const encryptedMnemonic = await encryptByKeyCardStyle({ pass, dispatch, plaintext: mnemonic, language });
        return formatToKeyCardStyle({ data: encryptedMnemonic });
      }
      else if (intent === 'plain') {
        return formatToSingleTextRecord({ data: mnemonic });
      }
      else {
        // useNfcrwWrite が書き込みを止め、onResult で失敗を知らせる
        throw new Error(`unknown intent: ${intent}`);
      }
    },
    onReadyToWrite: () => {
      dispatch({ type: 'setNotification', key: 'notification', value: words.readyToWriteEncryptedData[language] });
    },
    onResult: ({ ok, error }) => notifyNativeAppWriteResult({ dispatch, language, ok, error }),
  });

  let readButtons = [];
  let writeButtons = [];

  const keyboxButton =
    <>
      <div className='widthMax marginTop1 '>
        { words.readKeyboxMnemonic[language] }
      </div>
      <button className='buttonMainColor widthMin20 heightMin4 flexRow justifyContentCenter alignItemsCenter marginTop1 ' tabindex='0'
        onClick={ async () => {
          try {
            dispatch({ type: 'setStateMultiLayers', keys: ['passkey', 'busy'], value: true });
            const {
              decryptedMnemonicRecords: mnemonicRecords,
              decryptedWifRecords: wifRecords,
              keyPairs,
            } = await handleClickAuthenticate({ dispatch, network, language });

            const secretRecordsByAddress = new Map(
              [ ...mnemonicRecords, ...wifRecords ].map( (secretRecord) => [ secretRecord.address, secretRecord ] )
            );
            const keyPairsToLogin = Array.from(secretRecordsByAddress.values())
            .filter( ( secretRecord ) => user[secretRecord.address]?.basicInformation === undefined )
            .map( ( secretRecord ) => secretRecord.keyPair );

            if (keyPairsToLogin.length >= 1) {
              handleClickLogin({
                dispatch,
                popupLayer: popupLayerNext + 1, // selectSecretPopup の上に描画する。
                keyPairs: keyPairsToLogin,
                sessionToOverride: {},
                login,
                walletType,
                session,
                marginOfSessionTime,
                assetInfos,
                monacards,
                network,
                clientParameters,
                language,
              })
              .catch( () => {
                // 握りつぶす
              });
            }

            if (mnemonicRecords.length === 0) {
              dispatch({ type: 'setNotification', key: 'notification', value: words.noMnemonicRecordsFound[language] });
              throw new Error('No mnemonic records found');
            }

            const { mnemonic } = await new Promise( (resolve, reject) => {
              const popup = {
                type: 'selectSecretPopup',
                body: {
                  secretRecords: mnemonicRecords,
                  resolve,
                  reject,
                },
              };

              dispatch({ type: 'setStateMultiLayers', keys: ['popup', popupLayerNext], value: popup });
            });

            handleClickDisplayMnemonic({ dispatch, mnemonics: [mnemonic] });
            dispatch({ type: 'setNotification', key: 'notification', value: words.readingDone[language] });
            keepKeyPairsInMemory({ dispatch, keyPairs, periodToKeepKeyPairs: clientParameters.periodToKeepKeyPairs, language, network });
          }
          finally {
            dispatch({ type: 'setStateMultiLayers', keys: ['passkey', 'busy'], value: false });
          }
        }}
      >
        <div>
        { words.read[language] }
        </div>
        <div>
          <img className='size2x2' src={iconKeyBox} alt='' />
        </div>
      </button>
    </>;

  const nfcButton =
    <>
      <div className='widthMax marginTop1 '>
        { words.readKeyCardNfcMnemonic[language] }
      </div>
      <button className='buttonMainColor widthMin20 heightMin4 flexRow justifyContentCenter alignItemsCenter marginTop1 ' tabindex='0'
        onClick={ async () => {
          dispatch({ type: 'setNotification', key: 'notification', value: words.touchWithYourKeyCard[language] });
          const records = await new Promise( (resolve, reject) => {
            readNfc({ dispatch, resolve, reject, language });
          });

          const recordNo = 1;
          const record = records?.[recordNo];

          const encryptedMnemonic = decodeNdefRecord({ dispatch, record, language });
          const mnemonic = await decryptByKeyCardStyle({ pass, dispatch, encrypted: encryptedMnemonic, language });
          handleClickDisplayMnemonic({ dispatch, mnemonics: [mnemonic] });
          dispatch({ type: 'setNotification', key: 'notification', value: words.readingDone[language] });
        }}
      >
        <div>
          { words.read[language] }
        </div>
        <div>
          <img className='size2x2' src={iconKeyCard} alt='' />
        </div>
      </button>
    </>;

  const nfcPlainButton =
    <>
      <div className='widthMax marginTop1 '>
        { words.readNfcPlainTextMnemonic[language] }
      </div>
      <button className='buttonMainColor widthMin20 heightMin4 flexRow justifyContentCenter alignItemsCenter marginTop1 ' tabindex='0'
        onClick={ async () => {
          dispatch({ type: 'setNotification', key: 'notification', value: words.touchWithNfcTag[language] });
          const records = await new Promise( (resolve, reject) => {
            readNfc({ dispatch, resolve, reject, language });
          });

          const recordNo = 0;
          const record = records?.[recordNo];

          const text = decodeNdefRecord({ dispatch, record, language });
          handleClickDisplayMnemonic({ dispatch, mnemonics: [text] });
          dispatch({ type: 'setNotification', key: 'notification', value: words.readingDone[language] });
        }}
      >
        <div>
          { words.read[language] }
        </div>
        <div>
          <img className='size2x2' src={iconKeyCard} alt='' />
        </div>
      </button>
    </>;

  // ネイティブアプリで NFC を読み込む（アプリが読み取り結果を暗号化して返し、ブラウザでキーカード形式として復号する）
  const readKeyCardNfcWithNativeAppButton =
    <NativeAppReadButton
      nfcrwScan={nfcrwScan}
      intent='keycard'
      label={words.readKeyCardNfcMnemonicWithNativeApp[language]}
    />;

  // ネイティブアプリで NFC を読み込む（アプリが読み取り結果を暗号化して返し、ブラウザで復号する）
  const readNfcPlainTextWithNativeAppButton =
    <NativeAppReadButton
      nfcrwScan={nfcrwScan}
      intent='plain'
      label={words.readNfcPlainTextMnemonicWithNativeApp[language]}
    />;

  const qrButton =
    <>
      <div className='widthMax marginTop1 '>
        { words.readKeyCardBcMnemonic[language] }
      </div>
      <button className='buttonMainColor widthMin20 heightMin4 flexRow justifyContentCenter alignItemsCenter marginTop1 ' tabindex='0'
        onClick={ async () => {
          const encryptedMnemonic = await new Promise( (resolve, reject) => {
            const popup = {
              type: 'qrCodeReaderPopup',
              body: {
                resolve,
                reject,
              },
            };

            dispatch({ type: 'setStateMultiLayers', keys: ['popup', popupLayerNext], value: popup });
          });

          const mnemonic = await decryptByKeyCardStyle({ pass, dispatch, encrypted: encryptedMnemonic, language });
          handleClickDisplayMnemonic({ dispatch, mnemonics: [mnemonic] });
        }}
      >
        <div>
          { words.read[language] }
        </div>
        <div>
          <img className='size2x2' src={iconQr} alt='' />
        </div>
      </button>
    </>;

  const qrPlainButton =
    <>
      <div className='widthMax marginTop1 '>
        { words.read2dBarcodePlainTextMnemonic[language] }
      </div>
      <button className='buttonMainColor widthMin20 heightMin4 flexRow justifyContentCenter alignItemsCenter marginTop1 ' tabindex='0'
        onClick={ async () => {
          const data = await new Promise( (resolve, reject) => {
            const popup = {
              type: 'qrCodeReaderPopup',
              body: {
                resolve,
                reject,
              },
            };

            dispatch({ type: 'setStateMultiLayers', keys: ['popup', popupLayerNext], value: popup });
          });

          handleClickDisplayMnemonic({ dispatch, mnemonics: [data] });
        }}
      >
        <div>
          { words.read[language] }
        </div>
        <div>
          <img className='size2x2' src={iconQr} alt='' />
        </div>
      </button>
    </>;

  const mnemonicInputButton =
    <>
      <div className='widthMax marginTop1 '>
        { words.inputMnemonicAction[language] }
      </div>
      <button className='buttonMainColor widthMin20 heightMin4 flexRow justifyContentCenter alignItemsCenter marginTop1 ' tabindex='0'
        onClick={ () => {
          const popup = {
            type: 'mnemonicInputPopup',
            body: {
              stateKeys: ['displaySecret', 'mnemonic']
            },
          };

          dispatch({ type: 'setStateMultiLayers', keys: ['popup', popupLayerNext], value: popup });
        }}
      >
        <div>
          { words.input[language] }
        </div>
        <div>
          <img className='size2x2' src={iconEdit} alt='' />
        </div>
      </button>
    </>;

  const generateMnemonicButton =
    <>
      <div className='widthMax marginTop1 '>
        { words.generateMnemonic[language] }
      </div>
      <button className='buttonMainColor widthMin20 heightMin4 flexRow justifyContentCenter alignItemsCenter marginTop1 ' tabindex='0'
        onClick={ () => {
          const { mnemonic } = generateMnemonic({ dispatch, network, language });
          handleClickDisplayMnemonic({ dispatch, mnemonics: [mnemonic] });
        }}
      >
        <div>
          { words.generate[language] }
        </div>
      </button>
    </>;

  const writeInKeycardNfcFormatButton =
    <>
      <div className='widthMax marginTop1 '>
        { words.writeInKeyCardNfcFormat[language] }
      </div>
      <button className='buttonMainColor widthMin20 heightMin4 flexRow justifyContentCenter alignItemsCenter marginTop1 ' tabindex='0'
        onClick={ async () => {
          dispatch({ type: 'setNotification', key: 'notification', value: words.touchWithNfcTag[language] });

          const encryptedMnemonic = await encryptByKeyCardStyle({ pass, dispatch, plaintext: mnemonic, language });
          const records = formatToKeyCardStyle({ data: encryptedMnemonic });
          writeNdefRecordsOnNfc({ dispatch, records, language });
        }}
      >
        <div>
          { words.write[language] }
        </div>
        <div>
          <img className='size2x2' src={iconKeyCard} alt='' />
        </div>
      </button>
    </>;

  const writeInPlainTextToNfcButton =
    <>
      <div className='widthMax marginTop1 '>
        { words.writeInPlainTextToNfc[language] }
      </div>
      <button className='buttonMainColor widthMin20 heightMin4 flexRow justifyContentCenter alignItemsCenter marginTop1 ' tabindex='0'
        onClick={ () => {
          dispatch({ type: 'setNotification', key: 'notification', value: words.touchWithNfcTag[language] });

          const records = formatToSingleTextRecord({ data: mnemonic });
          writeNdefRecordsOnNfc({ dispatch, records, language });
        }}
      >
        <div>
          { words.write[language] }
        </div>
        <div>
          <img className='size2x2' src={iconKeyCard} alt='' />
        </div>
      </button>
    </>;

  // iPhone アプリでの 2 段の書き込み（1/2 鍵交換、2/2 書き込み）
  // 鍵交換セッションはプレーンテキストとキーカードで共有する。
  // 最後に完了した鍵交換が書き込みフォーマットを決める（先にプレーン、後にキーカードならキーカード形式。逆も同じ）。
  // 2回目の鍵交換が終わるまでは1回目の書き込みボタンが残る。そこで書くと1回目のフォーマットのままタグへ書かれる。
  const writeInKeyCardNfcFormatWithNativeAppButton =
    <NativeAppWriteButton
      nfcrwWrite={nfcrwWrite}
      intent='keycard'
      label={words.writeInKeyCardNfcFormatWithNativeApp[language]}
    />;

  const writeInPlainTextToNfcWithNativeAppButton =
    <NativeAppWriteButton
      nfcrwWrite={nfcrwWrite}
      intent='plain'
      label={words.writeInPlainTextToNfcWithNativeApp[language]}
    />;

  const displayQrInKeycardBcFormatButton =
    <>
      <div className='widthMax marginTop1 '>
        { words.display2dBarcodeInKeyCardBcFormat[language] }
      </div>
      <button className='buttonMainColor widthMin20 heightMin4 flexRow justifyContentCenter alignItemsCenter marginTop1 ' tabindex='0'
        onClick={ async () => {
          const encryptedMnemonic = await encryptByKeyCardStyle({ pass, dispatch, plaintext: mnemonic, language });

          const popup = {
            type: 'displayQrPopup',
            body: {
                data: encryptedMnemonic,
            },
          };

          dispatch({ type: 'setStateMultiLayers', keys: ['popup', popupLayerNext], value: popup });
        }}
      >
        <div>
          { words.display[language] }
        </div>
        <div>
          <img className='size2x2' src={iconQr} alt='' />
        </div>
      </button>
    </>;

  const displayQrInPlainTextButton =
    <>
      <div className='widthMax marginTop1 '>
        { words.display2dBarcodeInPlainText[language] }
      </div>
      <button className='buttonMainColor widthMin20 heightMin4 flexRow justifyContentCenter alignItemsCenter marginTop1 ' tabindex='0'
        onClick={ () => {
          const popup = {
            type: 'displayQrPopup',
            body: {
                data: mnemonic,
            },
          };

          dispatch({ type: 'setStateMultiLayers', keys: ['popup', popupLayerNext], value: popup });
        }}
      >
        <div>
          { words.display[language] }
        </div>
        <div>
          <img className='size2x2' src={iconQr} alt='' />
        </div>
      </button>
    </>;

  for (const wallet of walletsAvailable({ hasCamera })) {
    if (wallet === 'keybox') {
      readButtons.push(keyboxButton);
    }
    else if (wallet === 'nfc') {
      readButtons.push(nfcButton, nfcPlainButton);
      writeButtons.push(writeInKeycardNfcFormatButton, writeInPlainTextToNfcButton);
    }
    else if (wallet === 'nfcNative') {
      readButtons.push(readKeyCardNfcWithNativeAppButton, readNfcPlainTextWithNativeAppButton);
      writeButtons.push(writeInKeyCardNfcFormatWithNativeAppButton, writeInPlainTextToNfcWithNativeAppButton);
    }
    else if (wallet === 'qr') {
      readButtons.push(qrButton, qrPlainButton);
      writeButtons.push(displayQrInKeycardBcFormatButton, displayQrInPlainTextButton);
    }
  }

  readButtons.push(mnemonicInputButton, generateMnemonicButton);


  return (
    <div className='flexColumn alignItemsCenter borderKOM marginTop1 padding0p5'>
      <div className='flexRow justifyContentSpaceBetween alignItemsCenter widthMax marginTop1 '>
        <div>
          { words.readDisplayAndWriteMnemonic[language] }
        </div>
        <button className='borderNone backgroundColorTransparent cursor borderRadius2 riseOut2 marginSide0p2 ' tabindex='0'
          onClick={ () => handleClickClearMnemonic({ dispatch }) }
        >
          {words.clear[language]}
        </button>
      </div>
      <div className='widthMax colorRed marginTop1 '>
        { words.pleaseBeCarefulOfYourSurroundingsSoThatOthersCannotSee[language] }
      </div>
      { readButtons }
      <div className='flexColumn alignItemsFlexStart width90PC borderKOM marginTop1 padding0p5'>
        { mnemonic }
      </div>
      { writeButtons }
    </div>
  );
}

// DISPLAY WIF
function DisplayWif() {
  const { state, dispatch } = useGlobalStateSelector(({ state, dispatch }) => ({ state, dispatch }));
  const nativeAppAvailable = walletsAvailable({ hasCamera: state.device?.hasCamera }).includes('nfcNative');
  const language = state.language;
  const pass = state.config.clientParameters.specialMessage;
  const network = state.networkMona;

  // iPhone アプリでキーカードを読み、WIFを表示する
  const nfcrwScan = useNfcrwScan({
    enabled: nativeAppAvailable,
    language,
    onRecords: async ({ records }) => {
      let secrets;

      try {
        secrets = await getSecretsFromKeyCardRecords({ dispatch, pass, records, language, network });
      }
      catch {
        return;
      }

      handleClickDisplayWif({ dispatch, keyPairs: secrets.keyPairs });
    },
    onFailure: () => {
      dispatch({ type: 'setNotification', key: 'notification', value: words.failedToReadNfc[language] });
    },
  });

  let buttons;

  const nfcButton =
  <button className='buttonMainColor widthMin20 heightMin4 flexRow justifyContentCenter alignItemsCenter marginTop1 ' tabindex='0'
    onClick={ async () => {
      const callback = (keyPairs) => handleClickDisplayWif({ dispatch, keyPairs });
      handleClickNfc(state, dispatch, callback, { args: ['keyPairs'] });
    }}
  >
    <div>
      { words.display[state.language] }
    </div>
    <div>
      <img className='size2x2' src={iconKeyCard} alt='' />
    </div>
  </button>;

  const qrButton =
  <button className='buttonMainColor widthMin20 heightMin4 flexRow justifyContentCenter alignItemsCenter marginTop1 ' tabindex='0'
    onClick={ async () => {
      const callback = (keyPairs) => handleClickDisplayWif({ dispatch, keyPairs });
      handleClickScanQr(state, dispatch, callback, { args: ['keyPairs'] });
    }}
  >
    <div>
      { words.display[state.language] }
    </div>
    <div>
      <img className='size2x2' src={iconQr} alt='' />
    </div>
  </button>;

  // iPhone アプリでキーカードを読む（アプリが読み取り結果を暗号化して返し、ブラウザで復号する）
  const nativeAppButton =
  <NativeAppReadButton
    nfcrwScan={nfcrwScan}
    intent='keycard'
    face={
      <>
        <div>
          { words.display[language] }
        </div>
        <div>
          <img className='size2x2' src={iconKeyCard} alt='' />
        </div>
      </>
    }
  />;

  const availableButtons = [];

  if ('NDEFReader' in window) {
    availableButtons.push(nfcButton);
  }

  if (nativeAppAvailable) {
    availableButtons.push(nativeAppButton);
  }

  if (state.device.hasCamera) {
    availableButtons.push(qrButton);
  }

  if (availableButtons.length === 0) {
    return null;
  }

  buttons =
  <div className=''>
    { availableButtons }
  </div>;


  return (
    <div className='flexColumn alignItemsCenter borderKOM marginTop1 padding0p5'>
      <div className='flexRow justifyContentSpaceBetween alignItemsCenter widthMax marginTop1 '>
        <div>
          { words.displayWif[state.language] }
        </div>
        <button className='borderNone backgroundColorTransparent cursor borderRadius2 riseOut2 marginSide0p2 ' tabindex='0'
          onClick={ () => handleClickClearWif(state, dispatch) }
        >
          {words.clear[state.language]}
        </button>
      </div>
      <div className='widthMax colorRed marginTop1 '>
        { words.pleaseBeCarefulOfYourSurroundingsSoThatOthersCannotSee[state.language] }
      </div>
      { buttons }
      <div className='flexColumn alignItemsFlexStart width90PC borderKOM breakAll marginTop1 padding0p5'>
        { state.displaySecret.wif }
      </div>
    </div>
  );
}

// DISPLAY ADDRESS
function DisplayAddress() {
  const { state, dispatch } = useGlobalStateSelector(({ state, dispatch }) => ({ state, dispatch }));
  const nativeAppAvailable = walletsAvailable({ hasCamera: state.device?.hasCamera }).includes('nfcNative');
  const language = state.language;
  const pass = state.config.clientParameters.specialMessage;
  const network = state.networkMona;

  // iPhone アプリでキーカードを読み、アドレスを表示する
  const nfcrwScan = useNfcrwScan({
    enabled: nativeAppAvailable,
    language,
    onRecords: async ({ records }) => {
      let secrets;

      try {
        secrets = await getSecretsFromKeyCardRecords({ dispatch, pass, records, language, network });
      }
      catch {
        return;
      }

      handleClickDisplayAddress({ state, dispatch, keyPairs: secrets.keyPairs });
    },
    onFailure: () => {
      dispatch({ type: 'setNotification', key: 'notification', value: words.failedToReadNfc[language] });
    },
  });

  let buttons;

  const nfcButton =
  <button className='buttonMainColor widthMin20 heightMin4 flexRow justifyContentCenter alignItemsCenter marginTop1 ' tabindex='0'
    onClick={ async () => {
      const callback = (keyPairs) => handleClickDisplayAddress({ state, dispatch, keyPairs });
      handleClickNfc(state, dispatch, callback, { args: ['keyPairs'] });
    }}
  >
    <div>
      { words.display[state.language] }
    </div>
    <div>
      <img className='size2x2' src={iconKeyCard} alt='' />
    </div>
  </button>;

  const qrButton =
  <button className='buttonMainColor widthMin20 heightMin4 flexRow justifyContentCenter alignItemsCenter marginTop1 ' tabindex='0'
    onClick={ async () => {
      const callback = (keyPairs) => handleClickDisplayAddress({ state, dispatch, keyPairs });
      handleClickScanQr(state, dispatch, callback, { args: ['keyPairs'] });
    }}
  >
    <div>
      { words.display[state.language] }
    </div>
    <div>
      <img className='size2x2' src={iconQr} alt='' />
    </div>
  </button>;

  // iPhone アプリでキーカードを読む（アプリが読み取り結果を暗号化して返し、ブラウザで復号する）
  const nativeAppButton =
  <NativeAppReadButton
    nfcrwScan={nfcrwScan}
    intent='keycard'
    face={
      <>
        <div>
          { words.display[language] }
        </div>
        <div>
          <img className='size2x2' src={iconKeyCard} alt='' />
        </div>
      </>
    }
  />;

  const availableButtons = [];

  if ('NDEFReader' in window) {
    availableButtons.push(nfcButton);
  }

  if (nativeAppAvailable) {
    availableButtons.push(nativeAppButton);
  }

  if (state.device.hasCamera) {
    availableButtons.push(qrButton);
  }

  if (availableButtons.length === 0) {
    return null;
  }

  buttons =
  <div className=''>
    { availableButtons }
  </div>;


  return (
    <div className='flexColumn alignItemsCenter borderKOM marginTop1 padding0p5'>
      <div className='flexRow justifyContentSpaceBetween alignItemsCenter widthMax marginTop1 '>
        <div>
          { words.displayAddress[state.language] }
        </div>
        <button className='borderNone backgroundColorTransparent cursor borderRadius2 riseOut2 marginSide0p2 ' tabindex='0'
          onClick={ () => handleClickClearAddress(state, dispatch) }
        >
          {words.clear[state.language]}
        </button>
      </div>
      { buttons }
      <div className='flexColumn alignItemsFlexStart width90PC borderKOM breakAll marginTop1 padding0p5'>
        { state.displaySecret.address }
      </div>
    </div>
  );
}

// GET THE PRIVATE KEY FROM THE MNEMONIC
function GetThePrivateKeyFromTheMnemonic() {
  const { state, dispatch } = useGlobalStateSelector(({ state, dispatch }) => ({ state, dispatch }));


  return (
    <div className='flexColumn alignItemsCenter borderKOM marginTop1 padding0p5'>
      <div className='flexRow justifyContentSpaceBetween alignItemsCenter widthMax marginTop1 '>
        <div className='flexColumn alignItemsFlexStart '>
          <div>
            { words.getThePrivateKeyFromTheMnemonic[state.language] }
          </div>
          <div>
            { words.restoringToAnotherWalletFromABackup[state.language] }
          </div>
        </div>
        <button className='borderNone backgroundColorTransparent cursor borderRadius2 riseOut2 marginSide0p2 ' tabindex='0'
          onClick={ () => handleClickClearMnemonicAndWif(state, dispatch) }
        >
          {words.clear[state.language]}
        </button>
      </div>
      <div className='widthMax colorRed marginTop1 '>
        { words.pleaseBeCarefulOfYourSurroundingsSoThatOthersCannotSee[state.language] }
      </div>
      <TextArea2 fieldName='settingWifFromMnemonic' keys={['displaySecret', 'mnemonicToWif']} face={words.mnemonic[state.language]}
        outerClass='widthMax' boxClass='box4 width96PC marginTop1 ' textAreaClass='textArea1'
      />
      <button className='buttonMainColor widthMin20 heightMin4 flexRow justifyContentCenter alignItemsCenter marginTop1 ' tabindex='0'
        onClick={ () => {
          handleClickDisplayWifFromMnemonicFilledIn(state, dispatch);
        }}
      >
        <div>
          { words.display[state.language] }
        </div>
      </button>
      <div className='flexColumn alignItemsFlexStart width90PC borderKOM breakAll marginTop1 padding0p5'>
        { state.displaySecret.wifFromMnemonic }
      </div>
    </div>
  );
}

// // WRITE MNEMONIC ON NFC
// function WriteMnemonicOnNfc(props) {
//   const popupLayer = props.popupLayer;
//   const popupLayerNext = popupLayer !== undefined && popupLayer !== null ? (popupLayer + 1) : 0;
//   const language = useGlobalStateSelector( ({ state }) => state.language || 'english' );
//   const mnemonic = useGlobalStateSelector( ({ state }) => state.displaySecret.mnemonic );
//   const dispatch = useGlobalStateSelector( ({ dispatch }) => dispatch );
// 
//   let buttons;
// 
//   const keyboxButton =
//     <button className='buttonMainColor widthMin20 heightMin4 flexRow justifyContentCenter alignItemsCenter marginTop1 ' tabindex='0'
//       onClick={ async () => {
//         try {
//           dispatch({ type: 'setStateMultiLayers', keys: ['passkey', 'busy'], value: true });
//           const { decryptedMnemonicRecords: mnemonicRecords, keyPairs } = await handleClickAuthenticate(state, dispatch);
// 
//           const { mnemonic } = await new Promise( (resolve, reject) => {
//             const popup = {
//               type: 'selectMnemonicPopup',
//               body: {
//                 mnemonicRecords,
//                 resolve,
//                 reject,
//               },
//             };
// 
//             dispatch({ type: 'setStateMultiLayers', keys: ['popup', popupLayerNext], value: popup });
//           });
// 
//           handleClickDisplayMnemonic(state, dispatch, [mnemonic]);
//           keepKeyPairsInMemory(state, dispatch, keyPairs);
//         }
//         finally {
//           dispatch({ type: 'setStateMultiLayers', keys: ['passkey', 'busy'], value: false });
//         }
//       }}
//     >
//       <div>
//       { words.display[language] }
//       </div>
//       <div>
//         <img className='size2x2' src={iconKeyCard} alt='' />
//       </div>
//     </button>;
// 
//   const nfcButton =
//   <button className='buttonMainColor widthMin20 heightMin4 flexRow justifyContentCenter alignItemsCenter marginTop1 ' tabindex='0'
//     onClick={ async () => {
//       const callback = (mnemonics) => handleClickDisplayMnemonic(state, dispatch, mnemonics);
//       handleClickNfc(state, dispatch, callback, { args: ['mnemonics'] });
//     }}
//   >
//     <div>
//       { words.display[language] }
//     </div>
//     <div>
//       <img className='size2x2' src={iconKeyCard} alt='' />
//     </div>
//   </button>;
// 
//   const qrButton =
//   <button className='buttonMainColor widthMin20 heightMin4 flexRow justifyContentCenter alignItemsCenter marginTop1 ' tabindex='0'
//     onClick={ async () => {
//       const callback = (mnemonics) => handleClickDisplayMnemonic(state, dispatch, mnemonics);
//       handleClickScanQr(state, dispatch, callback, { args: ['mnemonics'] });
//     }}
//   >
//     <div>
//       { words.display[language] }
//     </div>
//     <div>
//       <img className='size2x2' src={iconQr} alt='' />
//     </div>
//   </button>;
// 
//   const writeOnNfcButton =
//     <button className='buttonMainColor widthMin20 heightMin4 flexRow justifyContentCenter alignItemsCenter marginTop1 ' tabindex='0'
//       onClick={ () => {
//         writeOnNfc(null, dispatch, mnemonic, { language });
//       }}
//     >
//       <div>
//         { words.write[language] }
//       </div>
//     </button>
// 
//   const displayQrButton =
//     <button className='buttonMainColor widthMin20 heightMin4 flexRow justifyContentCenter alignItemsCenter marginTop1 ' tabindex='0'
//       onClick={ () => {
//         const popup = {
//           type: 'displayQrPopup',
//           body: {
//               data: mnemonic,
//           },
//         };
// 
//         dispatch({ type: 'setStateMultiLayers', keys: ['popup', popupLayerNext], value: popup });
//       }}
//     >
//       <div>
//         { words.display[language] }
//       </div>
//     </button>
// 
//   if ('NDEFReader' in window && state.device.hasCamera) {
//     buttons =
//     <div className=''>
//       { keyboxButton }
//       { nfcButton }
//       { qrButton }
//     </div>;
//   }
//   else if ('NDEFReader' in window) {
//     buttons =
//     <div className=''>
//       { keyboxButton }
//       { nfcButton }
//     </div>;
//   }
//   else if (state.device.hasCamera) {
//     buttons =
//     <div className=''>
//       { keyboxButton }
//       { qrButton }
//     </div>;
//   }
//   else {
//     return null;
//   }
// 
//   return (
//     <div className='flexColumn alignItemsCenter borderKOM marginTop1 padding0p5'>
//       <div className='flexRow justifyContentSpaceBetween alignItemsCenter widthMax marginTop1 '>
//         <div>
//           { words.displayMnemonic[language] }
//         </div>
//         <button className='borderNone backgroundColorTransparent cursor borderRadius2 riseOut2 marginSide0p2 ' tabindex='0'
//           onClick={ () => handleClickClearMnemonic(state, dispatch) }
//         >
//           {words.clear[language]}
//         </button>
//       </div>
//       <div className='widthMax colorRed marginTop1 '>
//         { words.pleaseBeCarefulOfYourSurroundingsSoThatOthersCannotSee[language] }
//       </div>
//       { buttons }
//       <div className='flexColumn alignItemsFlexStart width90PC borderKOM marginTop1 padding0p5'>
//         { state.displaySecret.mnemonic }
//       </div>
//     </div>
//   );
// }

// ネイティブアプリからの復帰タブ。結果を localStorage に書いて案内だけ出す
function NfcCallback() {
  const language = useGlobalStateSelector( ({ state }) => state.language || 'english' );

  useEffect( () => {
    const url = new URL(window.location.href);
    const state = url.searchParams.get('state');
    const nfc = url.searchParams.get('nfc');
    const error = url.searchParams.get('error');
    const pubkey = url.searchParams.get('pubkey');
    const ciphertext = url.searchParams.get('ciphertext');

    if (state && (nfc || error || pubkey)) {
      writeNfcrwCallbackToLocalStorage({ state, nfc, error, pubkey, ciphertext });
    }

    url.search = '';
    window.history.replaceState({}, '', url);
  }, []);

  return (
    <div className='flexColumn alignItemsCenter marginTop1 padding0p5'>
      { words.pleaseReturnToTheOriginalTabAndCloseThisTab[language] }
    </div>
  );
}

// HANDLE CLICK SETTING
function handleClickSetting(state, dispatch, navigate) {
  navigate(process.env.REACT_APP_ENVIRONMENT === 'dev' ? '/build/setting' : '/setting');
}


// HANDLE CLICK DISPLAY MNEMONIC
function handleClickDisplayMnemonic({ dispatch, mnemonics }) {
  dispatch({ type: 'setStateMultiLayers', keys: ['displaySecret', 'mnemonic'], value: mnemonics[0] });
  // dispatch({ type: 'setStateMultiLayers', keys: ['displaySecret', 'mnemonicHidden'], value: mnemonics[0] });

  return;
}

// HANDLE CLICK CLEAR MNEMONIC
function handleClickClearMnemonic({ dispatch }) {
  dispatch({ type: 'setStateMultiLayers', keys: ['displaySecret', 'mnemonic'], value: '' });

  return;
}

// HANDLE CLICK DISPLAY WIF
function handleClickDisplayWif({ dispatch, keyPairs }) {
  dispatch({ type: 'setStateMultiLayers', keys: ['displaySecret', 'wif'], value: keyPairs[0].toWIF() });

  return;
}

// HANDLE CLICK CLEAR WIF
function handleClickClearWif(state, dispatch) {
  dispatch({ type: 'setStateMultiLayers', keys: ['displaySecret', 'wif'], value: '' });

  return;
}

// HANDLE CLICK DISPLAY ADDRESS
function handleClickDisplayAddress({ state, dispatch, keyPairs }) {
  let address;

  const result = getAddressFromKey(state, dispatch, keyPairs[0], state.networkMona);

  if (result.status === 'fulfilled') {
    address = result.address;
    dispatch({ type: 'setStateMultiLayers', keys: ['displaySecret', 'address'], value: address }); 
    return result;
  }
  else {
    dispatch({ type: 'setNotification', key: 'notification', value: words.failedToGetTheAddress[state.language] });
    return result;
  }
}

// HANDLE CLICK DISPLAY WIF FROM MNEMONIC FILLED IN
function handleClickDisplayWifFromMnemonicFilledIn(state, dispatch) {
  const mnemonicFilledIn = state.displaySecret.mnemonicToWif;

  if (!bip39.validateMnemonic(mnemonicFilledIn)) {
    dispatch({ type: 'setNotification', key: 'notification', value: words.invalidMnemonic[state.language] });
    dispatch({ type: 'setStateMultiLayers', keys: ['displaySecret', 'wifFromMnemonic'], value: '' });

    throw new Error('invalidMnemonic');
  }

  const keyPairs = getKeyPairsFromMnemonic({ dispatch, network: state.networkMona, mnemonic: mnemonicFilledIn, language: state.language });
  dispatch({ type: 'setStateMultiLayers', keys: ['displaySecret', 'wifFromMnemonic'], value: keyPairs[0].toWIF() });

  return;
}

// HANDLE CLICK CLEAR MNEMONIC AND WIF
function handleClickClearMnemonicAndWif(state, dispatch) {
  dispatch({ type: 'setStateMultiLayers', keys: ['displaySecret', 'mnemonicToWif'], value: '' });
  dispatch({ type: 'setStateMultiLayers', keys: ['displaySecret', 'wifFromMnemonic'], value: '' });

  return;
}

// HANDLE CLICK CLEAR ADDRESS
function handleClickClearAddress(state, dispatch) {
  dispatch({ type: 'setStateMultiLayers', keys: ['displaySecret', 'address'], value: '' });

  return;
}

export {
  Setting,
  NfcCallback,
  DisplayMnemonic,
  DisplayWif,
  DisplayAddress,
  GetThePrivateKeyFromTheMnemonic,
  UnregisterAddress,
  UnregisterCredential,
  SavePasswordEncryptedSecrets,
  LoadPasswordEncryptedSecrets,
  handleClickSetting,
  handleClickDisplayMnemonic,
  handleClickClearMnemonic,
  handleClickDisplayWif,
};
